export const DELETE_MODELTYPE = 'DELETE_MODELTYPE';
export const DELETE_MODELTYPE_SUCCESS = 'DELETE_MODELTYPE_SUCCESS';
export const DELETE_MODELTYPE_ERROR  = 'DELETE_MODELTYPE_ERROR';

export const MODELTYPE_LIST = 'MODELTYPE_LIST';
export const MODELTYPE_LIST_SUCCESS = 'MODELTYPE_LIST_SUCCESS';
export const MODELTYPE_LIST_ERROR = 'MODELTYPE_LIST_ERROR';

export const ADD_MODELTYPE = 'ADD_MODELTYPE';
export const ADD_MODELTYPE_SUCCESS = 'ADD_MODELTYPE_SUCCESS';
export const ADD_MODELTYPE_ERROR  = 'ADD_MODELTYPE_ERROR';

export const EDIT_MODELTYPE = 'EDIT_MODELTYPE';
export const EDIT_MODELTYPE_SUCCESS = 'EDIT_MODELTYPE_SUCCESS';
export const EDIT_MODELTYPE_ERROR = 'EDIT_MODELTYPE_ERROR';

export const MODELTYPE_DETAILS = 'MODELTYPE_DETAILS';
export const MODELTYPE_DETAILS_SUCCESS = 'MODELTYPE_DETAILS_SUCCESS';
export const MODELTYPE_DETAILS_ERROR = 'MODELTYPE_DETAILS_ERROR';